/*eslint-disable */

import axios from 'axios';
import {bus} from '@/main';
import compeleteDemoReq from '@/components/private/demo-request/complete-demo-req-popup/';
import countries from '@/services/country.json';
import demoRequestActivePopup from '@/components/private/demo-request/demo-request-active-popup/';
import feedbackLinkSendPopup from '@/components/private/demo-request/feedback-link-send-popup/';
import itemInfoPopup from '@/components/private/demo-request/item-info-popup/';
import {mapGetters} from 'vuex';
import moment from 'moment';
import multiDemoReqDeletePopup from '@/components/private/demo-request/multiple-delete-demo-req-popup';
import removeDemoReq from '@/components/private/demo-request/demo-req-remove-popup/';

var $ = window.jQuery = require('jquery');
export default {
  name: 'demo-request-all-list',
  components: {
    'item-info-popup' : itemInfoPopup,
    'complete-demo-req-popup' : compeleteDemoReq,
    'remove-demo-req' : removeDemoReq,
    'multi-demo-req-popup' : multiDemoReqDeletePopup,
    'demo-request-active-popup' :  demoRequestActivePopup,
    'feedback-link-send-popup': feedbackLinkSendPopup
  },
  props: [],
  data () {
    return {
      getAllDemoRequestListData:null,
      getAllDemoRequestListResults:[],
      nextPageUrl:false,
      domainLocationOrigin:'',
      countryList:[],
      infoPopupState:false,
      demoReqInfo:null,
      nextPageUrl:null,
      loadmoreData:null,
      userLoading:false,
      completeReqDemoPopupState:false,
      demoReqId:'',
      removeReqDemoPopupState:false,
      multiDemoReqDeletedState:false,
      multiDemoReqArr:[],
      demoReqActivePopupState:false,
      feedbackLinkPopupState:false
    }
  },
  computed: {
  ...mapGetters([
    'getAllDemoRequestListGetter',
  ]),
  getAllDemoRequestListMethod(){
    this.getAllDemoRequestListData = this.$store.getters.getAllDemoRequestListGetter.data;
    return;
  },
  setInitialStates(){
    if(this.getAllDemoRequestListData){
      this.getAllDemoRequestListResults = this.getAllDemoRequestListData.results;
      this.nextPageUrl = this.getAllDemoRequestListData.next;
    }
  }
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    this.domainLocationOrigin = process.env.VUE_APP_PUBLIC_URL;
    this.getAllDemoRequestListMethod;
    this.setInitialStates;
    bus.$on('feedbackLinkPopupStateBus', (data) => {
      this.feedbackLinkPopupState = data;
    });
    bus.$on('demoReqActivePopupStateBus', (data) => {
      this.demoReqActivePopupState = data;
    });
    bus.$on('demoReqInfoStateBus', (data) => {
      this.infoPopupState = data;
    });
    bus.$on('completeReqDemoPopupStateBus', (data) => {
      this.completeReqDemoPopupState = data;
    });
    bus.$on('removeReqDemoPopupStateBus', (data) => {
      this.removeReqDemoPopupState = data;
    });
    bus.$on('multiDemoReqDeletedStateBus', (data) => {
      this.multiDemoReqDeletedState = data;
      this.multiDemoReqArr = [];
    });
  },
  methods: {
    feedbackLinkPopupMethod(id){
      this.demoReqId = id;
      this.feedbackLinkPopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    demoRequestActivePopupMethod(id){
      this.demoReqId = id;
      this.demoReqActivePopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    multiDemoReqsDeletedMethod(){
      this.multiDemoReqDeletedState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    openRemoveReqDemoPopupMethod(id){
      this.demoReqId = id;
      this.removeReqDemoPopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    openCompleteReqDemoPopupMethod(id){
      this.demoReqId = id;
      this.completeReqDemoPopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data;
          this.nextPageUrl = this.loadmoreData.data.next;
          this.$set(this.getAllDemoRequestListData, 'next', this.nextPageUrl);
          if (this.loadmoreData) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.getAllDemoRequestListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false;
            }
          }
        });
    },
    openDemoReqInfoPopup(data) {
      this.demoReqInfo = data;
      this.infoPopupState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    urlClipBoardMethod(value) {
      const copyUrl = this.domainLocationOrigin + '/public/meeting/#' + value
      navigator.clipboard.writeText(copyUrl);
    },
    statusCheckOfMeeting(startTime, startDate){
      var currentLocalDate = moment().format('MMMM Do YYYY');
      var startDateCheck = moment(startDate).format('MMMM Do YYYY');
      var curentDateUTC = moment().format('h:mm a');
      if(startDateCheck === currentLocalDate){
        if (startTime > curentDateUTC){
          return true;
        }else{   
          return false;
        }
      }else{
        return true;
      }
    },
  },
  watch: {
    getAllDemoRequestListMethod(){
      return this.$store.getters.getAllDemoRequestListGetter;
    },
    setInitialStates(){
      if(this.getAllDemoRequestListData){
        this.getAllDemoRequestListResults = this.getAllDemoRequestListData.results;
        this.nextPageUrl = this.getAllDemoRequestListData.next;
      }
    }
  },
}